import PropTypes from "prop-types";
import React from "react";

// ----------------------------------------------------------------------------

export default function MarkerPointVertical(props) {
  const { markerHeight } = props;

  return (
    <div
      style={{
        backgroundColor: "#000000",
        width: 1,
        height: markerHeight + 20 ?? 100,
        marginTop: -25,
        marginLeft: 25,
      }}
    ></div>
  );
}

// -------------------------------------
// Component PropTypes and default props
// -------------------------------------

MarkerPointVertical.propTypes = {
  style: PropTypes.any,

  title: PropTypes.string,
  showSearchBar: PropTypes.bool,
  onBack: PropTypes.func,
  searchValue: PropTypes.string,
  onSearch: PropTypes.func,
  onCart: PropTypes.func,
  onPressSearch: PropTypes.func,
  renderExtraRow: PropTypes.func,
};
MarkerPointVertical.defaultProps = { style: {} };

// ----------------------------------------------------------------------------
